import { createStore } from '@servicetitan/financing-utils-shared';
import { ComponentType, useState } from 'react';

export interface ExternalApplicationWorkflows {
    ExternalApplicationWorkflow: ComponentType<unknown>;
}

function useExternalApplicationWorkflow(initialState: ExternalApplicationWorkflows) {
    const [externalApplication] = useState<ExternalApplicationWorkflows>(initialState);
    return externalApplication;
}

export const ExternalApplicationWorkflowStore = createStore(useExternalApplicationWorkflow);

export type ExternalApplicationWorkflowStoreValue = ReturnType<
    typeof useExternalApplicationWorkflow
>;
